"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const validation_1 = require("./validation");
const CategoryDialogForm = (props) => {
    const { selectedItem, open, mode, ...rest } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const { id, title, description, parentId } = selectedItem || {};
    const fixedValues = { id, title, description, parentId };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, message: `dialogs.${mode}`, validationSchema: validation_1.validationSchema, ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title" }), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description" }), (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "parentId", controller: "ecommerce/categories", label: formatMessage({ id: "form.labels.parentCategoryId" }), placeholder: formatMessage({ id: "form.placeholders.parentCategoryId" }) })] }));
};
exports.CategoryDialogForm = CategoryDialogForm;
//# sourceMappingURL=index.js.map